import request from '@/utils/request'

/**
 * 標籤左側列表
 * @param {*} data
 */
export function workTasklableIndexAPI(data) {
  return request({
    url: 'work/tasklable/index',
    method: 'post',
    data: data
  })
}

/**
 * 單個標籤詳情
 * @param {*} data
 */
export function workTasklableReadAPI(data) {
  return request({
    url: 'work/tasklable/read',
    method: 'post',
    data: data
  })
}

/**
 * 標籤刪除
 * @param {*} data
 */
export function workTasklableDeleteAPI(data) {
  return request({
    url: 'work/tasklable/delete',
    method: 'post',
    data: data
  })
}

/**
 * 標籤編輯
 * @param {*} data
 */
export function workTasklableSaveAPI(data) {
  return request({
    url: 'work/tasklable/save',
    method: 'post',
    data: data
  })
}

/**
 * 獲取專案及任務表
 * @param {*} data
 */
export function workTasklableGetWokListAPI(data) {
  return request({
    url: 'work/tasklable/getWokList',
    method: 'post',
    data: data
  })
}

/**
 * 編輯標籤
 * @param {*} data
 */
export function workTasklableUpdateAPI(data) {
  return request({
    url: 'work/tasklable/update',
    method: 'post',
    data: data
  })
}
